module.exports = __webpack_public_path__ + "static/images/info-circle.3xDh0SO.svg";